import type { ContentType, TestSource } from "@/types/ab-tests";
import type { EditableSection } from "./types";

export const SOURCE_LABELS: Record<TestSource, string> = {
  "ai-magic": "AI Magic",
  "ai-format": "AI Format",
  "brand-signal": "Brand Signal",
  keyword: "Keyword",
  landscape: "Landscape",
  "seo-insight": "SEO Insight",
  scorecard: "Amazon AI Score",
  "positioning-editor": "Positioning Editor",
  manual: "Manual",
  upload: "Upload",
};

export const SECTION_TITLE: Record<EditableSection, string> = {
  configuration: "Edit configuration",
  results: "Edit results",
  action: "Edit action",
};

export const SOURCE_OPTIONS: TestSource[] = [
  "ai-magic",
  "ai-format",
  "brand-signal",
  "keyword",
  "scorecard",
  "positioning-editor",
  "manual",
];

export const SCOPE_OPTIONS: ContentType[] = [
  "title",
  "bullet-1",
  "bullet-2",
  "bullet-3",
  "bullet-4",
  "bullet-5",
];

export const METRIC_ROWS: {
  key: "conversion" | "unitsPerUniqueVisitor" | "unitsSold" | "unitsSoldFromSearch" | "sales" | "salesFromSearch" | "sampleSize";
  label: string;
  numeric?: boolean;
}[] = [
  { key: "conversion", label: "Conversion" },
  { key: "unitsPerUniqueVisitor", label: "Units / Unique Visitor", numeric: true },
  { key: "unitsSold", label: "Units Sold", numeric: true },
  { key: "unitsSoldFromSearch", label: "Units Sold From Search", numeric: true },
  { key: "sales", label: "Sales" },
  { key: "salesFromSearch", label: "Sales From Search" },
  { key: "sampleSize", label: "Sample Size", numeric: true },
];
